export default __webpack_public_path__ + "58bbe063431a9d7dca46595f60199441.png";